import {
  BasketballGame,
  RequestBasketballPostGame,
  RequestBasketballUpdateSeasonPlanerTasks,
} from '@hefe/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../../api/api';

export const saveBasketballGame = createAsyncThunk(
  'basketballGames/save',
  async (data: RequestBasketballPostGame, thunkAPI) => {
    const response = await API.basketballGames().saveGame(data);
    return response?.data as BasketballGame;
  }
);

export const deleteBasketballGame = createAsyncThunk<any, number>(
  'basketballGames/delete',
  async (id: number, thunkAPI) => {
    const response = await API.basketballGames().delete(id);
    if (response) {
      return thunkAPI.fulfillWithValue(id);
    } else {
      return thunkAPI.rejectWithValue(null);
    }
  }
);

const setBasketballSeasonPlanerVisibleTasks = createAsyncThunk(
  'basketballGames/setTeamMeetingAt',
  async (data: RequestBasketballUpdateSeasonPlanerTasks, thunkAPI) => {
    const response =
      await API.basketballGames().updateBasketballSeasonPlanerVisibleTasks(
        data
      );
    return response?.data;
  }
);

export { setBasketballSeasonPlanerVisibleTasks };
